
(function () {
'use strict';

const STORAGE_KEY = 'KING_WISHLIST';


function loadList() {
try {
const raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
return Array.isArray(raw) ? raw : [];
} catch (e) {
return [];
}
}

function saveList(list) {
localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}


function formatMoney(cents) {
if (typeof cents !== 'number') return '';
const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
return (cents / 100).toFixed(2) + (cur ? (' ' + cur) : '');
}


function updateHeader() {
const count = loadList().length;

document.querySelectorAll('.king-wishlist-count').forEach(el => {
el.textContent = String(count);
el.hidden = (count === 0);
});

document.querySelectorAll('.king-header-wishlist .king-heart').forEach(btn => {
btn.classList.toggle('active', count > 0);
});
}


function syncButtons(root) {
const scope = root || document;
const list = loadList();

scope.querySelectorAll('.king-heart[data-handle]').forEach(btn => {
btn.classList.toggle('active', list.includes(btn.dataset.handle));
});
}


function toggleHandle(handle) {
if (!handle) return;

let list = loadList();

if (list.includes(handle)) {
list = list.filter(h => h !== handle);
} else {
list.push(handle);
}

saveList(list);
updateHeader();
syncButtons(document);
renderWishlistPage();
}


function renderWishlistPage() {
const mount = document.getElementById('king-wishlist-mount');
if (!mount) return;

const list = loadList();

if (!list.length) {
mount.innerHTML = '<p style="text-align:center">No favorites yet.</p>';
return;
}

mount.innerHTML =
'<div class="king-wishlist-grid">' +
list.map(() => '<div class="king-wishlist-card loading">Loading…</div>').join('') +
'</div>';

Promise.all(
list.map(handle =>
fetch('/products/' + handle + '.js')
.then(r => (r.ok ? r.json() : null))
.catch(() => null)
)
).then(products => {
const grid = mount.querySelector('.king-wishlist-grid');
if (!grid) return;

grid.innerHTML = '';

products.filter(Boolean).forEach(p => {
const card = document.createElement('div');
card.className = 'king-wishlist-card';

const variantId = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : '';

card.innerHTML =
'<img src="' + p.featured_image + '" alt="' + (p.title || '') + '">' +
'<div class="king-wishlist-info">' +
'<a href="/products/' + p.handle + '">' + (p.title || '') + '</a>' +
'<div class="king-wishlist-price">' + formatMoney(p.price) + '</div>' +
'<button class="king-wishlist-add" data-variant="' + variantId + '">Add to Bag</button>' +
'</div>' +
'<span class="king-wishlist-remove" data-remove="' + p.handle + '">✕</span>';

grid.appendChild(card);
});
});
}


function injectHearts(root) {
const scope = root || document;

scope.querySelectorAll('.king-heart-anchor').forEach(anchor => {
// Never inject into menus/nav/header
if (anchor.closest('.menu-drawer, nav, .header__menu, .header, .mega-menu')) return;

if (anchor.querySelector('.king-heart')) return;

const handle = anchor.dataset.handle;
if (!handle) return;

const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'king-heart';
btn.setAttribute('aria-label', 'Add to wishlist');
btn.dataset.handle = handle;

anchor.appendChild(btn);
});

syncButtons(scope);
}


function drawOverlayHearts() {
if (window.location.pathname !== '/') return;

document.querySelectorAll('.card-wrapper').forEach(card => {
if (card.querySelector('.king-heart-overlay')) return;

const link = card.querySelector('a[href*="/products/"]');
if (!link) return;

const href = link.getAttribute('href') || '';
const m = href.match(/\/products\/([^\/\?#]+)/);
if (!m) return;

const handle = m[1];

if (getComputedStyle(card).position === 'static') {
card.style.position = 'relative';
}

const heart = document.createElement('button');
heart.type = 'button';
heart.className = 'king-heart king-heart-overlay';
heart.dataset.handle = handle;
heart.setAttribute('aria-label', 'Add to wishlist');

heart.style.position = 'absolute';
heart.style.top = '10px';
heart.style.right = '10px';
heart.style.zIndex = '100000';
heart.style.pointerEvents = 'auto';

card.appendChild(heart);
});
}

function onGlobalClick(e) {
// Remove from wishlist page
const removeBtn = e.target.closest('[data-remove]');
if (removeBtn) {
e.preventDefault();
e.stopPropagation();
e.stopImmediatePropagation();

const handle = removeBtn.dataset.remove;
let list = loadList().filter(h => h !== handle);
saveList(list);

const card = removeBtn.closest('.king-wishlist-card');
if (card) {
card.classList.add('removing');
setTimeout(() => card.remove(), 300);
}

updateHeader();
syncButtons(document);

if (!list.length) {
const mount = document.getElementById('king-wishlist-mount');
if (mount) mount.innerHTML = '<p>No favorites yet.</p>';
}
return;
}


const addBtn = e.target.closest('.king-wishlist-add');
if (addBtn) {
e.preventDefault();
e.stopPropagation();

const variant = addBtn.dataset.variant;
if (!variant) return;

const card = addBtn.closest('.king-wishlist-card');

fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: variant, quantity: 1 })
}).then(() => {
if (card) {
card.classList.add('added-to-cart');
addBtn.textContent = 'Added';
addBtn.disabled = true;
}
});

return;
}

const clearBtn = e.target.closest('#king-wishlist-clear');
if (clearBtn) {
e.preventDefault();

saveList([]);
const mount = document.getElementById('king-wishlist-mount');
if (mount) mount.innerHTML = '<p>No favorites yet.</p>';

updateHeader();
syncButtons(document);
return;
}


const heart = e.target.closest('.king-heart');
if (heart) {
if (heart.closest('.king-header-wishlist')) return;

e.preventDefault();
e.stopPropagation();
e.stopImmediatePropagation();

toggleHandle(heart.dataset.handle);
return;
}
}


function init() {
updateHeader();
syncButtons(document);
renderWishlistPage();
injectHearts(document);
drawOverlayHearts();
}

document.addEventListener('click', onGlobalClick, true);

document.addEventListener('DOMContentLoaded', init);

document.addEventListener('shopify:section:load', e => {
syncButtons(e.target);
injectHearts(e.target);
drawOverlayHearts();
});

})();

window.addEventListener('pageshow', function () {
if (typeof syncButtons === 'function') {
syncButtons(document);
}
if (typeof updateHeader === 'function') {
updateHeader();
}
});

/* ===== Auto-preview on hover (desktop) ===== */
(function () {
const DELAY = 600;

function setup(card) {
const img = card.querySelector('.card__media img, img');
if (!img || img.dataset.kingAuto) return;

const data = img.getAttribute('data-images');
let images = [];

if (data) {
images = data.split(',').map(s => s.trim()).filter(Boolean);
} else {
const srcset = img.getAttribute('srcset');
if (!srcset) return;
images = srcset.split(',').map(s => s.trim().split(' ')[0]).filter(Boolean);
}

if (images.length < 2) return;

img.dataset.kingAuto = '1';
let t, i = 0, first = img.src;

if (window.matchMedia('(hover: hover)').matches) {
img.addEventListener('mouseenter', () => {
t = setTimeout(() => {
i = 1; img.src = images[i];
}, DELAY);
});
img.addEventListener('mouseleave', () => {
clearTimeout(t);
i = 0; img.src = first;
});
}
}

function init(root=document){ root.querySelectorAll('.card-wrapper').forEach(setup); }
document.addEventListener('DOMContentLoaded', ()=>init());
document.addEventListener('shopify:section:load', e=>init(e.target));
})();


